
import React, { Component } from 'react';
import { SketchPicker } from 'react-color';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";
import ColorSet from './ColorSet';
import { Select } from 'antd';

export default class ColorSetSelectEditor extends PropertyEditor {
    constructor(props, context) {
        super(props, context);
        this.state = {
            // colors: []
        }
    }
    componentDidMount() {

    }

    // componentWillReceiveProps(nextProps) {
    //     super.componentWillReceiveProps(nextProps);
    //     if (nextProps.value === this.props.value)
    //         return;

    //     this.setState({ colors: nextProps.value });
    // }
    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }
    onChange(colors) {
        this.props.source.value = [...colors.split(';')];
        this.setState({})
    }
    render() {
        let colorsArray = [...this.props.source.values || []];
        let value = this.props.source.value || [];
        value = value.join ? value.join(';') : [];
        return (
            <Select className="propertygrid-editor-colorset" value={value} onChange={this.onChange.bind(this)} style={{}}>
                {colorsArray.map((colors, index) => {
                    return <Select.Option value={colors.join(';')} key={index}>
                        <div key={index} style={{
                            overflow: "hidden",
                            height: "30px"
                        }}>
                            <ColorSet style={{
                                marginTop: "3px"
                            }} colorStyle={{
                                width: "24px",
                                height: "24px"
                            }} colors={colors} onlyDisplay={true}></ColorSet>
                        </div>
                    </Select.Option>
                })}
            </Select>


        );
    }
}

PropertyGridUtils.register("colorSetSelect", (source, propertyGrid) => <ColorSetSelectEditor source={source} propertyGrid={propertyGrid} />);